<button type="button" tabindex="-1" class="btn btn-link pl-0 pr-0 {{class}}" [container]="'body'" [ngbPopover]="popContent"
  triggers="manual" #p="ngbPopover" (click)="toggle(); $event.stopPropagation()"
  [popoverTitle]="'financial.price-structure'|translate">
   {{price|money}} <i class="fa fa-info"></i>
</button>
<ng-template #popContent>
   <jbm-price-rules-table [pricerules]="pricerules" [isConcrete]="false"></jbm-price-rules-table>
</ng-template>
